// src/components/Modals/DummyModal.jsx
import React from 'react';

const DummyModal = ({ show, onClose, message, title }) => {
    if (!show) return null;
    return (
        <div style={{
            position: 'fixed',
            top: '30%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: '20px 40px',
            zIndex: 1050,
            border: '1px solid #ccc',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
        }}>
            {title && <h4 style={{ marginTop: 0, marginBottom: '15px' }}>{title}</h4>}
            <p>{message || "This is a dummy modal."}</p>
            <button onClick={onClose} style={{ padding: '8px 15px', cursor: 'pointer' }}>Close</button>
        </div>
    );
};

export default DummyModal;